import { QUERY_PARAMS } from 'constants/path';
import dayjs from 'dayjs';

export function getCustomDateFromParams(searchParams) {
  const timeFromParam = searchParams.get(QUERY_PARAMS.time);
  if (!timeFromParam) {
    return [];
  }

  const dates = timeFromParam.split('-');

  const day0 = dayjs(dates[0]);
  const day1 = dayjs(dates[1]);

  if (day0.isValid() && day1.isValid()) {
    return [day0, day1];
  }

  return [];
}
